























import { FileHelper } from '@getaccept/lib-shared/src/file/helpers/file.helper';
import {
  MAX_FILES,
  SIZE_LIMIT,
} from '@getaccept/lib-shared/src/attachments/constants/upload-attachment';
import { allAcceptedFileTypes } from '@getaccept/lib-shared/src/file/constants/accepted-file-types';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { PropType } from '@vue/composition-api';
import { defineComponent, ref, computed } from '@vue/composition-api';

export default defineComponent({
  props: {
    fileName: {
      type: String,
      default: '',
    },
    acceptedFileTypes: {
      type: Array as PropType<string[]>,
      default: () => allAcceptedFileTypes,
    },
    maxNumberOfFiles: {
      type: Number,
      default: MAX_FILES,
    },
    sizeLimit: {
      type: Number,
      default: SIZE_LIMIT,
    },
  },
  setup(props, { emit }) {
    const activeFileHover = ref(false);
    const warningMessage = ref(null);
    const inputRef = ref<HTMLInputElement>(null);

    const uploadTitle = computed(() => {
      if (warningMessage.value) {
        return warningMessage.value;
      }
      if (props.fileName) {
        return props.fileName;
      }
      return t('click-or-drop-files-here-to-upload');
    });

    const resetWarningMessage = () => {
      warningMessage.value = null;
    };

    const resetInputField = () => {
      resetWarningMessage();
      const inputElement = inputRef.value;
      inputElement.value = '';
    };

    const handleDrop = (files: File[]) => {
      const file: File = files[0];
      const fileType: string = FileHelper.extractFileType(file.name);
      if (FileHelper.validFileType(fileType)) {
        handleChange(files);
      } else {
        warningMessage.value = t('file-format-not-supported');
      }
      activeFileHover.value = false;
    };

    const handleDragOver = (elementId: string) => {
      if (elementId === 'upload-file-button') {
        activeFileHover.value = true;
      }
    };

    const handleDragLeave = (elementId: string) => {
      if (elementId === 'upload-file-button') {
        activeFileHover.value = false;
      }
    };

    const handleChange = (files: File[]) => {
      resetWarningMessage();
      const file: File = files[0];
      if (!file) {
        return;
      }
      if (files.length > props.maxNumberOfFiles) {
        warningMessage.value = t('one-file-at-a-time');
        return;
      }
      if (file.size > props.sizeLimit) {
        warningMessage.value = t('file-is-over-size-limit');
        return;
      }
      emit('selectFile', file);
    };

    return {
      activeFileHover,
      warningMessage,
      inputRef,
      uploadTitle,
      resetWarningMessage,
      resetInputField,
      handleDrop,
      handleDragOver,
      handleDragLeave,
      handleChange,
    };
  },
});
